export const SEND_EMAILS_START = 'SEND_EMAILS_START';
export const SEND_EMAILS_SUCCESS = 'SEND_EMAILS_SUCCESS';
export const SEND_EMAILS_ERROR = 'SEND_EMAILS_ERROR';
